import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/common/routes/requireAuth'
import PageDeactivate from '@/pages/account/deactivate'

export const Route = createFileRoute('/app/account/deactivate')({
  beforeLoad: ({ context }) => {
    requireAuth(context)
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <PageDeactivate />
}
